import type * as React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ImagesLayout } from './ImagesLayout'

import {
  MasonryContainer,
  NoResultsLayout,
  TextWithoutMarginTop,
} from './styles'

import type { GraphImage, IntegrationsService } from '../../types'

const MAX_WINDOW_SIZE = 10

export const SearchImagesResults = ({
  images = [],
  getMore,
  loading,
  loader,
  service,
}: {
  images: GraphImage[]
  getMore: () => void
  loading: boolean
  loader: React.ReactElement
  service: IntegrationsService
}): JSX.Element => {
  if (images?.length === 0 && loading) {
    return loader
  }

  if (images?.length === 0 && !loading) {
    return (
      <NoResultsLayout>
        <TextWithoutMarginTop type="h3">
          No results for that search
        </TextWithoutMarginTop>
        <TextWithoutMarginTop type="p">
          Try again with another word
        </TextWithoutMarginTop>
      </NoResultsLayout>
    )
  }

  return (
    <MasonryContainer id="scrollableContainer">
      <InfiniteScroll
        dataLength={images ? images.length : 0}
        hasMore={images.length >= MAX_WINDOW_SIZE}
        next={getMore}
        loader={loader}
        scrollableTarget="scrollableContainer"
      >
        <ImagesLayout images={images} service={service} />
      </InfiniteScroll>
    </MasonryContainer>
  )
}
